import { createFileRoute } from '@tanstack/react-router'
import LoginPage from '@/components/pages/LoginPage/LoginPage'

export const Route = createFileRoute('/login/device/')({
  component: DeviceLoginIndexRoute,
})

function DeviceLoginIndexRoute() {
  return <LoginPage />
}
